import React, { Component, Fragment } from 'react';

// import DesktopRegister from './DesktopRegister/DesktopRegister';
import Mobile from './Mobile/Mobile';
import Desktop from './Desktop/Desktop';

export default class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      events: [
        {
          id: 0,
          title: 'ویدئو کنفرانس با شرکت داده ',
          time: '9:45',
          description: 'جلسه با آقای علی و حسین در مورد سرمایه‌گذاری',
          color: '#06C8F9'
        },
        {
          id: 1,
          title: 'ویدئو کنفرانس با شرکت',
          time: '9:45',
          description: 'جلسه با آقای علی و حسین در مورد سرمایه‌گذاری',
          color: '#5436f2'
        },
        {
          id: 2,
          title: 'ویدئو کنفرانس با شرکت داده پرداز',
          time: '9:45',
          description: 'جلسه با آقای علی و حسین در مورد سرمایه‌گذاری',
          color: '#f25532'
        }
      ],
      doneList: [],
      selectedDay: { year: 1399, month: 10, day: 20 },
      religious_times: [
        { name: 'صبح', value: '15:19' },
        { name: 'طلوع', value: '15:19' },
        { name: 'ظهر', value: '15:19' },
        { name: 'عصر', value: '15:19' },
        { name: 'غروب', value: '15:19' },
        { name: 'مغرب', value: '15:19' },
        { name: 'عشا', value: '15:19' },
        { name: 'نیمه شب', value: '15:19' },
      ],
      monasebat: [
        { id: 0, name: "سالروز فتح خرمشهر به دست رزمندگان اسلام", color: "#2345ff" },
        { id: 1, name: "روز دانشجو", color: "#903312" }
      ],
      filters: [
        { id: 0, name: 'شخصی', color: '#2FA4FE' },
        { id: 1, name: 'کاری', color: '#26D32C' },
        { id: 2, name: 'وظایف', color: '#F6FF00' },
        { id: 3, name: 'رویداد', color: '#F26A1D' },
      ],
    }
  }

  setSelectedDay = (value) => {
    this.setState({
      selectedDay: value,
    })
  }

  addDone = (obj, id) => {
    setTimeout(() => {
      this.state.doneList.push(obj);
      this.setState({
        events: this.state.events.filter(event => event.id !== id),
      })
    }, 500)
  }

  deleteDone = (obj, id) => {
    setTimeout(() => {
      this.state.events.push(obj);
      this.setState({
        doneList: this.state.doneList.filter(done => done.id !== id),
      })
    }, 500);
  }

  render() {
    let home;
    if (window.innerWidth > 900) {
      home = <Desktop
        events={this.state.events}
        doneList={this.state.doneList}
        religious_times={this.state.religious_times}
        monasebat={this.state.monasebat}
        selectedDay={this.state.selectedDay}
        deleteDone={this.deleteDone}
        addDone={this.addDone}
        setSelectedDay={this.setSelectedDay}
        filters={this.state.filters} />;
    }
    else if (window.innerWidth < 900) {
      home = <Mobile
        events={this.state.events}
        doneList={this.state.doneList}
        religious_times={this.state.religious_times}
        monasebat={this.state.monasebat}
        selectedDay={this.state.selectedDay}
        deleteDone={this.deleteDone}
        addDone={this.addDone}
        setSelectedDay={this.setSelectedDay} />;
    }
    return (
      <Fragment>
        { home}
      </Fragment>
    );
  }
}

